// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22.5 2V18H6.87574L1.5 22.7038V2H22.5ZM13 14V6H11V14H13ZM18 14V9H16V14H18ZM8 14V11H6V14H8Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chat-poll-filled')
export default class ChatPollFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chat-poll-filled',
    }
  }
}
